/**
 * Created by toomasp on 04.07.2016.
 */
import {viewport} from "./viewport/viewport.component";
import {error404} from "core/components/blank/error404.component";

export let components = angular.module('eservice.core.component', ['eservice.core'])
    .component('viewport', viewport)
    .component('error404', error404)

;




// WEBPACK FOOTER //
// ./src/main/ui/core/components/components.ts